export const CLASS_NAMES = {
  container: 'flex flex-row relative mb-5 md:mb-8',
  description: 'text-style-g-em text-neutral-600 w-36',
  content: 'flex flex-row flex-1 justify-between relative',
  children: 'flex flex-row flex-1 mr-8 z-0',
};
